<template>
<v-container fluid class="grey lighten-4">
  <v-dialog v-model="show_preview" :width="600">
    <v-card>
      <v-card-title class="secondary white--text">
        Email Preview
        <v-spacer></v-spacer>
        <v-btn dark icon @click="show_preview=false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-tabs v-model="tab" background-color="secondary lighten-1 white--text" dark>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          Html
        </v-tab>
        <v-tab href="#tab-2">
          Text
        </v-tab>
      </v-tabs>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field label="Subject" :value="preview.subject"></v-text-field>
          </v-col>
        </v-row>
      </v-container>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <div v-html="preview.html">

            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-card flat>
            <v-card-text>
              <v-textarea :rows="16" outlined :value="preview.text" readonly></v-textarea>
            </v-card-text>


          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
  <v-row>
    <v-col cols="12" class="text-right">
      <v-btn color="cool_purple" dark @click="getPreview" v-if="!modified" :loading="loading">Preview</v-btn>
      <v-btn color="green" class="ml-2" dark @click="save" v-if="modified" :loading="loading">Save</v-btn>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" md="10">
      <v-text-field label="Description (internal)" v-model="item.description"></v-text-field>
    </v-col>
    <v-col cols="12" md="2">
      <v-switch :true-value="1" :false-value="0" label="Active" v-model="item.active" color="green"></v-switch>
    </v-col>
    <v-col cols="12">
      <v-text-field label="Subject" v-model="item.subject"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-text-field label="Headline" v-model="item.headline"></v-text-field>
    </v-col>
    <v-col cols="12">
        <v-textarea :rows="10" v-model="item.message" label="Message"></v-textarea>
    </v-col>
    <v-col cols="12">
      <v-text-field label="Button Text" v-model="item.action_text"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-text-field label="Button Url" v-model="item.action_url"></v-text-field>
    </v-col>
  </v-row>

</v-container>
</template>
<script>
export default {
  props: ['value'],
  name: "",
  data: () => ({
    tab: 'tab-1',
    show_preview: false,
    loading: false,
    preview: {
      html: 'saddadas',
      text: 'asdasdas'
    },
    modified: false
  }),
  created() {

  },
  beforeDestroy() {

  },
  watch: {
    'item': {
      handler: function(to, from) {
        if (to && from) {
          this.modified = true
        }
      },
      deep: true
    }
  },
  computed: {
    item() {
      return this.value
    }
  },
  methods: {
    async getPreview() {
      try {
        this.loading = true;
        let preview = await this.$api({
          method: "GET",
          url: `/account/admin/email-notification-templates/${this.item.id}/preview`
        })
        this.preview = preview;
        this.show_preview = true
      } catch (ex) {
        alert(`Error! ${ex.error}`)
      }
      this.loading = false;
    },
    async save() {
      try {
        this.loading = true;
        await this.$api({
          method: "POST",
          url: `/account/admin/email-notification-templates/${this.item.id}`,
          data: this.item
        })
        setTimeout(function() {
          this.modified = false
        }.bind(this), 100)
      } catch (ex) {
        alert(`Error! ${ex.error}`)
      }
      this.loading = false;
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
